export enum ValidationMessages {
  REQUIRED = 'required',
  INVALID = 'invalid',
  MINIMUM = 'minimum',
  MAXIMUM = 'maximum',
  NOTMATCHING = 'notmatching',
}

export enum IdNowUserFieldStatus {
  CHANGED = "changed",
  MATCH = "match",
  NEW = "new",
}

export enum IdTypes {
  ID = 'id',
  PASSPORT = 'passport',
}

export enum AssetTypes {
  REAL_ESTATE = 'real_estate',
  LOAN = 'loan',
}

export enum EducationLevel {
  PRIMARY_EDUCATION = "primary_education",
  SECONDARY_EDUCATION = "secondary_education",
  ACADEMIC_DEGREE = "academic_degree",
  PROFESSIONAL_DEVELOPMENT = "professional_development",
  OTHER = "other",
}

export enum XpectoEventCategory {
  MEDIATION_CONTRACTS = "Vermittlungsvertrag",
  Legitimation = "Legitimation",
}

export enum XpectoInvestmentType {
  INVESTMENT_FUND = "0",
  GOVERNMENT_BONDS = "1",
  MONEY_MARKET_FUNDS = "2",
  BOND = "3",
  SHARE = "4",
  CERTIFICATE = "5",
  REVERSE_CONVERTIBLE_BOND = "6",
  ALTERNATIVE_INVESTMENT_FUND = "7",
  WARRANTS = "8",
  EMERGING_MARKET_BONDS = "9",
  HEDGE_FUND = "10",
  FUTURES_TRADING = "11",
  PARTICIPATION_RIGHT = "12",
  PARTICIPATION_PAPER = "13",
  OPERATIVE_PARTICIPATION_IN_A_LIMITED_PARTNERSHIP = "14",
  PARTICIPATION_IN_A_LIMITED_PARTNERSHIP = "15",
  CONTRACT_FOR_DIFFERENCE = "16",
  CRYPTO_CURRENCY = "17",
  UNSECURED_JUNIOR_DEBT = "18",
  PRIVATE_EQUITY = "19",
  FIXED_DEPOSIT = "20",
}

export enum InvestmentClass {
  INVESTMENT_FUND = "investment_fund",
  BOND = "bond",
  SHARE = "share",
  PARTICIPATION_RIGHT = "participation_right",
  UNSECURED_JUNIOR_DEBT = "unsecured_junior_debt",
  PRIVATE_EQUITY = "private_equity",
  CRYPTO_CURRENCY = "crypto_currency",
}

export enum ActivityType {
  WP_SERVICE = "wp_service",
}

export enum AverageYearlyTransactionsType {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum AverageYearlyVolumeType {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  VERY_HIGH = 'very_high',
}

export enum ExperienceLevel {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum FileExtensions {
  JPEG = 'jpeg',
  PNG = 'png',
  PDF = 'pdf',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
}

export enum IdNowStatus {
  NEEDS_APPROVAL = "needs_approval",
  CREATED = "created",
  SUCCESS = "success",
  FRAUD_SUSPICION_CONFIRMED = "fraud_suspicion_confirmed",
}

export enum InvestmentStatusValues {
  AWAITING_PAYMENT = 'awaiting_payment',
  CONFIRMED = 'confirmed',
  REVOKE_REQUESTED = 'revoke_requested',
  REVOKED = 'revoked',
  CANCELED = 'canceled',
  REFUNDED = 'refunded',
  UNPAID = 'unpaid',
}

export enum InvestmentSelector {
  ALL = 'all',
}

export type InvestmentFilter = InvestmentStatusValues | InvestmentSelector;

export enum LegalEntityType {
  AG = 'ag',
  GBR = 'gbr',
  GMBH = 'gmbh',
  KG = "kg",
  STIFTUNG = 'stiftung',
  UG = 'ug',
}

export enum MimeTypes {
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
  APPLICATION_PDF = 'application/pdf',
}

export enum SaleStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  PAUSED = 'paused',
  FINALIZATION_PENDING = 'finalization_pending',
  FINISHED = 'finished',
  ABORTED = 'aborted',
}

export enum SaleInterestPayoutPeriod {
  QUARTERLY = 'quarterly',
  BIANNUAL = 'biannual',
  YEARLY = 'yearly',
}

export enum SortSalesBy {
  RECENTLY_STARTED = 'recently_started',
  ALMOST_ENDING = 'almost_ending',
  HIGHEST_INTEREST_RATE = 'highest_interest_rate',
  MOST_SOLDOUT = 'most_soldout',
}

export enum PaymentMethodType {
  CREDIT_CARD = 'credit_card',
  SEPA_DIRECT_DEBIT = 'sepa_direct_debit',
  WIRE_TRANSFER = 'wire_transfer',
}

export enum RoleNames {
  USER = 'user',
  ADMIN = 'admin',
  SYSTEM = 'system',
}

export enum UpdateFrequency {
  NotUpdatable = 'notupdatable',
  ConditionallyUpdatable = 'conditionallyupdatable',
  Updatable = 'updatable',
}

export enum UserDocumentType {
  EFFECTA_AGB = "effecta_agb",
  EFFECTA_KUNDENINFORMATIONEN = "effecta_kundeninformationen",
  FINPRO_AGB = "finpro_agb",
  IDNOW_PDF = "idnow_pdf",
  IDNOW_XML = "idnow_xml",
  IDNOW_AUDIOLOG = "idnow_audiolog",
  IDNOW_VIDEOLOG = "idnow_videolog",
  IDNOW_USERFACE = "idnow_userface",
  IDNOW_IDBACKSID = "idnow_idbackside",
  IDNOW_IDFRONTSIDE = "idnow_idfrontside",
  IDNOW_LIVENESSLEFT = "idnow_livenessleft",
  IDNOW_LIVENESSRIGHT = "idnow_livenessright",
  IDNOW_SECURITY1 = "idnow_security1",
  IDNOW_SECURITY2 = "idnow_security2",
  IDNOW_SECURITY3 = "idnow_security3",
  IDNOW_SECURITY4 = "idnow_security4",
  IDNOW_SECURITY_COVERED = "idnow_security_covered"
}

export enum WalletStatus {
  ACTIVE = 'active',
  TRANSFERRED = 'transferred',
}

export enum CostCalculationPercentageType {
  MONETARY_CONTRIBUTIONS = "monetary_contributions",
  THEREOF_FACILITATOR = "thereof_facilitator",
  BROKERAGE_COSTS = "brokerage_costs",
  THEREOF_CONTRIBUTIONS = "thereof_contributions",
  FINANCIAL_INSTITUTION_COST = "financial_institution_cost",
  FINANCIAL_INSTRUMENT_COST = "financial_instrument_cost",
  COMPLETE_PERIOD_COST = "complete_period_cost",
  REDUCED_RETURN_FIRST_YEAR = "reduced_return_first_year",
  REDUCED_RETURN_FOLLOWING_YEARS = "reduced_return_following_years",
}

export enum PropertyType {
  RICH_TEXT = 'rich_text',
  CORE_PROPERTY = 'core_property',
  MEDIA = 'media'
}

export const isEnumValue = (value: any) => {
  return (
    Object.values(ValidationMessages).includes(value) ||
    Object.values(IdTypes).includes(value) ||
    Object.values(AssetTypes).includes(value) ||
    Object.values(XpectoInvestmentType).includes(value) ||
    Object.values(InvestmentClass).includes(value) ||
    Object.values(ExperienceLevel).includes(value) ||
    Object.values(FileExtensions).includes(value) ||
    Object.values(InvestmentStatusValues).includes(value) ||
    Object.values(InvestmentSelector).includes(value) ||
    Object.values(MimeTypes).includes(value) ||
    Object.values(SaleStatus).includes(value) ||
    Object.values(SaleInterestPayoutPeriod).includes(value) ||
    Object.values(SortSalesBy).includes(value) ||
    Object.values(PaymentMethodType).includes(value) ||
    Object.values(RoleNames).includes(value) ||
    Object.values(WalletStatus).includes(value)
  );
};
